import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { MatSnackBar } from '@angular/material';
import { PaiementService } from 'app/views/paiement/paiement.service';
import { MtnService } from './mtn.service';
import { Operateur } from './../models/operateur.model';
import { Md5 } from 'ts-md5/dist/md5';
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ConfigService } from 'ngx-envconfig';
import { Subscription } from 'rxjs';
import { ResultatPaiement } from '../models/resultatPaiement.model';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { Afpaynotif } from '../models/afpay.model';

@Injectable({
  providedIn: 'root'
})
export class AutreService {

  items: any[];

  // Subscription
  getCurlSub: Subscription;

  constructor(
    private logger: NGXLogger,
    private configService: ConfigService,
    private paiementService: PaiementService,
    private loader: AppLoaderService,
    private snack: MatSnackBar,
    private route: Router,
    private http: HttpClient,
  ) { }

  /**
   * Fonction pour generer token
   * @param idpanier
   * @param apiKey
   * @param idcustomer
   */
  genererToken (idpanier, apiKey, idcustomer) {
    // this.logger.trace('Params entrants pour token', idpanier, apiKey, idcustomer);
    const token = Md5.hashStr(idpanier + '' + apiKey + '' + idcustomer);
    // this.logger.trace('token', token);
    return token;
  }

   /**
   * Fonction pour convertir le Franc CFA en euro
   * return string
   * @param totalpaid
   */
  public conversionFrancToEuro(totalpaid: string): string {
    console.log((Number(totalpaid) / this.configService.get('euroValue')).toFixed(2));
    return (Number(totalpaid) / this.configService.get('euroValue')).toFixed(2);
  }

  /**
   * Fonction pour retourner sur le site marchand
   * @param urlFeed
   * @param resultat
   */
  retourSiteMarchand(urlFeed: string, resultat?, idcustomer?: string, idcart?: string,op?:String, redirectType?:String,afpaynotif?:Afpaynotif) {

    let urlRetour: string;
    let urlFeedFinal = atob(urlFeed);
    // Verifier que l'URL ne contient pas deja des parametres
    const checkUrl = urlFeedFinal.split('?');
    if (checkUrl.length > 1) { // Contient des params
      urlRetour = urlFeedFinal + '&tid=' + resultat.achattransactionid + '&status=' + resultat.achatfinalstatut + '&idcart=' + idcart + '&idcustomer=' + idcustomer + '&op=' + op + '&achat=' + JSON.stringify(resultat);
    } else {
      urlRetour = urlFeedFinal + '?tid=' + resultat.achattransactionid + '&status=' + resultat.achatfinalstatut + '&idcart=' + idcart + '&idcustomer=' + idcustomer + '&op=' + op + '&achat=' + JSON.stringify(resultat);
    }

    // urlRetour = urlFeedFinal + '?tid=' + resultat.achattransactionid + '&status=' + resultat.achatfinalstatut + '&idcart=' + idcart + '&idcustomer=' + idcustomer + '&op=' + op;

    this.logger.trace('URL RETOUR', urlRetour);
  if(redirectType == "GET" || redirectType == "get" || redirectType == "" || redirectType == null) { // Redirection vers le site marchand
    window.location.href = urlRetour;
  } else {
    console.log("On va faire un POST");
    this.paiementService.postresponse(urlRetour,afpaynotif).subscribe(data => {
      console.log(data);
      this.loader.close();
      this.route.navigate(['/result'], { queryParams: { achat: resultat} });
      
    });
      // 
  }

}

  /**
   * Fonction pour mettre à jour un site prestashop
   * @param curl
   * @param token
   * @param opPaiement
   * @param urlFeed
   */
  curlUrlRetour(curl, token, opPaiement, urlFeed: string,tid:String, redirectType:String,achatstats:String) {

    this.logger.trace('OBJ CURL ENTRANT', curl, token, opPaiement, urlFeed);
    let urlfinal = atob(curl) + '&success=' + token + '&op=' + opPaiement + '&tid=' + tid + '&achatstatus=' + achatstats;
    let urlcrypter = btoa(urlfinal);
    this.logger.trace('CONVERSION urlfinal', urlfinal, ' urlcrypter ', urlcrypter);

    let urlFeedDecrypter = atob(urlFeed);

    this.getCurlSub = this.paiementService.curlMS(urlcrypter)
    .subscribe(data => {

      let statuscode = data.status;

      switch (statuscode) {
        case 200: {
          this.snack.open('Commande mise à jour', 'OK', { duration: 4000 });
          let urlSuccess = urlFeedDecrypter + '&success=' + token + '&curlresp=' + true + '&tid=' + tid + '&op=' + opPaiement + '&achatstatus=' + achatstats;
          // Redirection vers la page de commande (historique prestashop)
           window.location.href = urlSuccess; // Si success
          break;
        }
        default: {
          this.loader.close();
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }
      }
    },
    error => {
      let statuscode = error.status;

      this.logger.error('Erreur' + error.error, error);

      let urlSuccess = urlFeedDecrypter + '&success=' + token + '&curlresp=' + false + '&tid=' + tid + '&op=' + opPaiement + '&achatstatus=' + achatstats;
      this.logger.trace('url', urlSuccess);
      // Redirection vers la page de commande (historique prestashop)
      window.location.href = urlSuccess; // Si echec

      switch (statuscode) {
        case 400: {
          this.loader.close();
          let urlSuccess = urlFeedDecrypter + '&success=' + token + '&curlresp=' + false + '&tid=' + tid + '&op=' + opPaiement + '&achatstatus=' + achatstats;
          // Redirection vers la page de commande (historique prestashop)
          window.location.href = urlSuccess; // Si echec

          break;
        }
        default: {
          this.loader.close();
          let urlSuccess = urlFeedDecrypter + '&success=' + token + '&curlresp=' + false + '&tid=' + tid + '&op=' + opPaiement + '&achatstatus=' + achatstats;
          this.logger.trace('url', urlSuccess);
          // Redirection vers la page de commande (historique prestashop)
          window.location.href = urlSuccess; // Si echec
          this.snack.open('Une erreur est survenue!', 'OK', { duration: 4000 });
          break;
        }

      }

    } );
  }

  // https://kyrmannpay.com:9241/kyrmannpay/dataresource/clientfournisseur/findsecurekeyforclf/smsmarketing
  getClientKey(login:string){
    return this.http.get('https://kyrmannpay.com:9241/kyrmannpay/dataresource/clientfournisseur/findsecurekeyforclf/'+ login, {
      observe: 'response',
    });
  }

}
